// Local SEO landing pages – unique content per city + service.
// Each entry renders at /{slug} via LocationPage.jsx.

export const locations = [
  {
    slug: "taktvatt-stockholm",
    service: "Taktvätt",
    city: "Stockholm",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Stockholm – skonsam takrengöring | HPR",
    description:
      "Professionell taktvätt i Stockholm. Skonsam mjuktvätt som tar bort mossa, alger och lav utan att skada takpannorna. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Stockholm",
    kicker: "Taktvätt · Stockholms län",
    intro: [
      "Stockholms fuktiga klimat och skiftande årstider gör att mossa, alger och lav snabbt får fäste på taket – särskilt på norrsidor och i skuggiga villaområden. HPR utför skonsam taktvätt i hela Storstockholm med egna certifierade team, aldrig underleverantörer.",
      "Vi använder i första hand lågtrycks-mjuktvätt med biologiskt nedbrytbara medel som löser upp påväxten utan att slita på takytan. Resultatet: ett rent, snyggt tak som håller tätt längre – och ett fast pris utan överraskningar, med ROT-avdraget avdraget direkt på fakturan.",
    ],
    areas: ["Bromma", "Enskede", "Vällingby", "Hägersten", "Kungsholmen", "Södermalm", "Spånga", "Farsta"],
  },
  {
    slug: "takmalning-stockholm",
    service: "Takmålning",
    city: "Stockholm",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Stockholm – måla taket med garanti | HPR",
    description:
      "Takmålning i Stockholm av egna proffs. Grundning + två strykningar kvalitetsfärg, upp till 10 års garanti. Fast pris och ROT-avdrag. Begär kostnadsfri offert.",
    h1: "Takmålning i Stockholm",
    kicker: "Takmålning · Stockholms län",
    intro: [
      "Ett målat tak i Stockholm håller både snyggt och tätt i många år till – men bara om jobbet görs rätt. HPR tvättar först taket rent från mossa och alger, åtgärdar brister och målar sedan med en beprövad process: grundning följt av två strykningar väderbeständig kvalitetsfärg.",
      "Vi målar tegel-, betong- och plåttak i hela Storstockholm med egna team. Du får ett fast pris, tydlig tidsplan och upp till 10 års garanti på utfört arbete – och vi sköter hela ROT-administrationen åt dig.",
    ],
    areas: ["Bromma", "Enskede", "Vällingby", "Hägersten", "Solna", "Sundbyberg", "Spånga", "Farsta"],
  },
  {
    slug: "taktvatt-uppsala",
    service: "Taktvätt",
    city: "Uppsala",
    region: "Uppsala län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Uppsala – ta bort mossa & alger | HPR",
    description:
      "Taktvätt i Uppsala med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och fri besiktning på plats.",
    h1: "Taktvätt i Uppsala",
    kicker: "Taktvätt · Uppsala län",
    intro: [
      "Runt Uppsala, med mycket grönska och skogsnära villaområden, är påväxt av mossa och alger på taket ett vanligt problem. HPR har egna team på plats i Uppsala och utför skonsam taktvätt som skyddar takpannorna och förlänger takets livslängd.",
      "Istället för aggressiv högtryckstvätt använder vi lågtrycks-mjuktvätt med miljövänliga medel som bryter ner påväxten. Du får en kostnadsfri besiktning, ett fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Gamla Uppsala", "Sävja", "Sunnersta", "Gottsunda", "Luthagen", "Årsta", "Storvreta", "Gränby"],
  },
  {
    slug: "takmalning-uppsala",
    service: "Takmålning",
    city: "Uppsala",
    region: "Uppsala län",
    priceFrom: "26 600 kr",
    title: "Takmålning Uppsala – måla taket med 10 års garanti | HPR",
    description:
      "Takmålning i Uppsala av egna certifierade takproffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Uppsala",
    kicker: "Takmålning · Uppsala län",
    intro: [
      "Vill du slippa byta tak i onödan? En professionell takmålning i Uppsala fräschar upp taket och skyddar det mot väder och vind i många år framåt. HPR rengör alltid taket noggrant innan vi målar, så färgen fäster som den ska.",
      "Vår process är beprövad: mjuktvätt, grundning och två strykningar väderbeständig färg. Med egna team, fast pris och upp till 10 års garanti kan du känna dig trygg – och vi sköter ROT-avdraget åt dig.",
    ],
    areas: ["Gamla Uppsala", "Sävja", "Sunnersta", "Gottsunda", "Luthagen", "Årsta", "Storvreta", "Gränby"],
  },
  {
    slug: "taktvatt-nacka",
    service: "Taktvätt",
    city: "Nacka",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Nacka – rengöring av tak nära vatten | HPR",
    description:
      "Taktvätt i Nacka och Saltsjöbaden. Sjönära hus drabbas ofta av alger och mossa – vi rengör skonsamt med mjuktvätt. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Nacka",
    kicker: "Taktvätt · Nacka & Saltsjöbaden",
    intro: [
      "De sjönära villaområdena i Nacka och Saltsjöbaden är vackra – men den fuktiga luften gör att alger och mossa trivs extra bra på taken här. HPR utför skonsam taktvätt i hela Nacka med egna takproffs.",
      "Vi arbetar med lågtrycks-mjuktvätt och miljövänliga medel som tar bort påväxten utan att skada taket. Du får fri besiktning, ett fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Saltsjöbaden", "Boo", "Fisksätra", "Saltsjö-Boo", "Älta", "Orminge", "Sickla", "Duvnäs"],
  },
  {
    slug: "takmalning-nacka",
    service: "Takmålning",
    city: "Nacka",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Nacka – måla taket med garanti | HPR",
    description:
      "Takmålning i Nacka och Saltsjöbaden av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg, upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Nacka",
    kicker: "Takmålning · Nacka & Saltsjöbaden",
    intro: [
      "I det sjönära och väderutsatta Nacka sätts taken på hårda prov. En takmålning från HPR ger taket ett nytt, hållbart skyddande ytskikt – och ett rejält ansiktslyft på köpet.",
      "Vi tvättar först taket rent, grundar och målar sedan med två strykningar väderbeständig färg. Med egna team, fast pris och upp till 10 års garanti är du i trygga händer. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Saltsjöbaden", "Boo", "Fisksätra", "Saltsjö-Boo", "Älta", "Orminge", "Sickla", "Duvnäs"],
  },
  {
    slug: "taktvatt-taby",
    service: "Taktvätt",
    city: "Täby",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Täby – skonsam takrengöring | HPR",
    description:
      "Taktvätt i Täby och Roslagen. Vi tar bort mossa, alger och lav med skonsam mjuktvätt som skyddar takpannorna. Fast pris, ROT-avdrag och kostnadsfri besiktning.",
    h1: "Taktvätt i Täby",
    kicker: "Taktvätt · Täby & Roslagen",
    intro: [
      "I Täbys många villaområden är mossa och alger på taket ett återkommande problem, särskilt på äldre tegel- och betongtak. HPR utför skonsam taktvätt i Täby med egna certifierade team.",
      "Vi använder lågtrycks-mjuktvätt med biologiskt nedbrytbara medel som löser upp påväxten utan att skada takytan. Du får en kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Näsbypark", "Gribbylund", "Roslags-Näsby", "Viggbyholm", "Ella Gård", "Skarpäng", "Hägernäs", "Vallentuna"],
  },
  {
    slug: "takmalning-taby",
    service: "Takmålning",
    city: "Täby",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Täby – måla taket med 10 års garanti | HPR",
    description:
      "Takmålning i Täby av egna takproffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag. Begär offert.",
    h1: "Takmålning i Täby",
    kicker: "Takmålning · Täby & Roslagen",
    intro: [
      "En takmålning i Täby förlänger takets livslängd och lyfter hela husets utseende. HPR rengör alltid taket ordentligt innan vi målar, så att färgen fäster och håller i många år.",
      "Vår beprövade process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av våra egna team till ett fast pris med upp till 10 års garanti. Vi sköter ROT-administrationen åt dig.",
    ],
    areas: ["Näsbypark", "Gribbylund", "Roslags-Näsby", "Viggbyholm", "Ella Gård", "Skarpäng", "Hägernäs", "Vallentuna"],
  },

  {
    slug: "taktvatt-solna",
    service: "Taktvätt",
    city: "Solna",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Solna – skonsam takrengöring | HPR",
    description: "Taktvätt i Solna för villor och bostadsrättsföreningar. Skonsam mjuktvätt som tar bort mossa och alger. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Solna",
    kicker: "Taktvätt · Solna",
    intro: [
      "I tätbebyggda Solna finns allt från villor i Huvudsta och Bergshamra till större bostadsrättsföreningar – och gemensamt för dem är att mossa och alger gärna sätter sig på taket. HPR utför skonsam taktvätt i hela Solna med egna certifierade team.",
      "Vi använder lågtrycks-mjuktvätt med biologiskt nedbrytbara medel som tar bort påväxten utan att skada takpannorna. Du får fri besiktning, ett fast pris och – för privatpersoner – ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Huvudsta", "Bergshamra", "Hagalund", "Råsunda", "Bagartorp", "Järva", "Ulriksdal", "Frösunda"],
  },
  {
    slug: "takmalning-solna",
    service: "Takmålning",
    city: "Solna",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Solna – måla taket med garanti | HPR",
    description: "Takmålning i Solna av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Solna",
    kicker: "Takmålning · Solna",
    intro: [
      "En takmålning i Solna ger huset ett rejält ansiktslyft och skyddar taket mot väder och vind i många år framåt. HPR rengör alltid taket ordentligt innan vi målar, så att färgen fäster och håller.",
      "Vår beprövade process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till ett fast pris med upp till 10 års garanti. Vi sköter ROT-administrationen åt dig.",
    ],
    areas: ["Huvudsta", "Bergshamra", "Hagalund", "Råsunda", "Bagartorp", "Järva", "Ulriksdal", "Frösunda"],
  },
  {
    slug: "taktvatt-sollentuna",
    service: "Taktvätt",
    city: "Sollentuna",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Sollentuna – ta bort mossa & alger | HPR",
    description: "Taktvätt i Sollentuna med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och kostnadsfri besiktning.",
    h1: "Taktvätt i Sollentuna",
    kicker: "Taktvätt · Sollentuna",
    intro: [
      "Sollentunas många villaområden – från Edsberg till Norrviken och Rotebro – har ofta äldre tegel- och betongtak där mossa och alger snabbt får fäste. HPR utför skonsam taktvätt i hela Sollentuna med egna takproffs.",
      "Istället för aggressiv högtryckstvätt använder vi lågtrycks-mjuktvätt med miljövänliga medel som skyddar taket. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Edsberg", "Norrviken", "Rotebro", "Häggvik", "Tureberg", "Viby", "Sjöberg", "Helenelund"],
  },
  {
    slug: "takmalning-sollentuna",
    service: "Takmålning",
    city: "Sollentuna",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Sollentuna – 10 års garanti | HPR",
    description: "Takmålning i Sollentuna av egna certifierade takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Sollentuna",
    kicker: "Takmålning · Sollentuna",
    intro: [
      "Vill du förlänga takets livslängd och slippa byta tak i onödan? En professionell takmålning i Sollentuna fräschar upp taket och ger ett hållbart skydd i många år. HPR tvättar alltid taket rent innan målning.",
      "Med vår process – grundning och två strykningar väderbeständig färg – och egna team levererar vi ett fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Edsberg", "Norrviken", "Rotebro", "Häggvik", "Tureberg", "Viby", "Sjöberg", "Helenelund"],
  },
  {
    slug: "taktvatt-sigtuna",
    service: "Taktvätt",
    city: "Sigtuna",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Sigtuna & Märsta – skonsam takrengöring | HPR",
    description: "Taktvätt i Sigtuna och Märsta med skonsam mjuktvätt. Vi tar bort mossa och alger utan att skada taket. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Sigtuna",
    kicker: "Taktvätt · Sigtuna & Märsta",
    intro: [
      "I Sigtuna och Märsta, med både äldre bebyggelse och nyare villaområden nära Mälaren, är fuktig luft och skiftande väder en perfekt grogrund för mossa och alger på taken. HPR utför skonsam taktvätt i hela kommunen med egna team.",
      "Vi arbetar med lågtrycks-mjuktvätt och biologiskt nedbrytbara medel som löser upp påväxten skonsamt. Du får fri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Märsta", "Sigtuna stad", "Valsta", "Steninge", "Rosersberg", "Sätuna", "Til", "Arlanda"],
  },
  {
    slug: "takmalning-sigtuna",
    service: "Takmålning",
    city: "Sigtuna",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Sigtuna & Märsta – med garanti | HPR",
    description: "Takmålning i Sigtuna och Märsta av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Sigtuna",
    kicker: "Takmålning · Sigtuna & Märsta",
    intro: [
      "Ett väderutsatt tak i Sigtuna eller Märsta mår bra av en professionell takmålning som ger det ett nytt, skyddande ytskikt. HPR rengör alltid taket noggrant innan vi målar så att resultatet håller länge.",
      "Vår process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. Vi sköter hela ROT-administrationen.",
    ],
    areas: ["Märsta", "Sigtuna stad", "Valsta", "Steninge", "Rosersberg", "Sätuna", "Til", "Arlanda"],
  },
  {
    slug: "taktvatt-enkoping",
    service: "Taktvätt",
    city: "Enköping",
    region: "Uppsala län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Enköping – skonsam takrengöring | HPR",
    description: "Taktvätt i Enköping med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och kostnadsfri besiktning på plats.",
    h1: "Taktvätt i Enköping",
    kicker: "Taktvätt · Enköping",
    intro: [
      "Enköping – \"Sveriges närmaste stad\" – har många villaområden med grönska runt husen, vilket gör att mossa och alger gärna sätter sig på taken. HPR utför skonsam taktvätt i Enköping med egna certifierade team.",
      "Vi använder lågtrycks-mjuktvätt med miljövänliga medel som tar bort påväxten utan att slita på takytan. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Centrala Enköping", "Romberga", "Bergvreten", "Korsängen", "Munksundet", "Fanna", "Örsundsbro", "Grillby"],
  },
  {
    slug: "takmalning-enkoping",
    service: "Takmålning",
    city: "Enköping",
    region: "Uppsala län",
    priceFrom: "26 600 kr",
    title: "Takmålning Enköping – måla taket med 10 års garanti | HPR",
    description: "Takmålning i Enköping av egna takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Enköping",
    kicker: "Takmålning · Enköping",
    intro: [
      "En takmålning i Enköping lyfter husets utseende och skyddar taket mot väder och vind i många år framåt. HPR rengör alltid taket ordentligt innan vi målar, så att färgen fäster och håller.",
      "Vår beprövade process med grundning och två strykningar väderbeständig färg utförs av egna team till fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Centrala Enköping", "Romberga", "Bergvreten", "Korsängen", "Munksundet", "Fanna", "Örsundsbro", "Grillby"],
  },

  {
    slug: "solcellstvatt-stockholm",
    service: "Solcellstvätt",
    city: "Stockholm",
    region: "Stockholms län",
    priceFrom: "3 499 kr",
    heroImage: "/solceller.png",
    title: "Solcellstvätt Stockholm – upp till 20% mer effekt | HPR",
    description: "Professionell solcellstvätt i Stockholm med avjoniserat vatten. Rena paneler ger upp till 20% mer effekt. Fasta paketpriser från 3 499 kr.",
    h1: "Solcellstvätt i Stockholm",
    kicker: "Solcellstvätt · Stockholms län",
    intro: [
      "Damm, pollen, fågelspillning och sot lägger sig snabbt på solpanelerna i Stockholm och kan sänka produktionen med upp till 20%. HPR utför skonsam solcellstvätt i hela Storstockholm med egna team.",
      "Vi tvättar panelerna med avjoniserat (rent) vatten – helt kemikaliefritt och repfritt – så att de producerar maximalt igen. Du väljer ett fast paketpris efter antal paneler, utan överraskningar.",
    ],
    areas: ["Bromma", "Enskede", "Vällingby", "Hägersten", "Solna", "Sundbyberg", "Spånga", "Farsta"],
  },
  {
    slug: "solcellstvatt-uppsala",
    service: "Solcellstvätt",
    city: "Uppsala",
    region: "Uppsala län",
    priceFrom: "3 499 kr",
    heroImage: "/solceller.png",
    title: "Solcellstvätt Uppsala – rena paneler, mer el | HPR",
    description: "Solcellstvätt i Uppsala med avjoniserat vatten. Ta bort damm, pollen och fågelspillning – få upp till 20% mer effekt. Fasta paketpriser från 3 499 kr.",
    h1: "Solcellstvätt i Uppsala",
    kicker: "Solcellstvätt · Uppsala län",
    intro: [
      "Runt Uppsala, med mycket pollen och grönska, blir solpanelerna snabbt smutsiga – och smutsiga paneler ger mindre el. HPR utför skonsam solcellstvätt i Uppsala med egna team på plats.",
      "Med avjoniserat vatten tvättar vi panelerna repfritt och helt utan kemikalier, så att de åter producerar för fullt. Du väljer ett fast paketpris efter antal paneler.",
    ],
    areas: ["Gamla Uppsala", "Sävja", "Sunnersta", "Gottsunda", "Luthagen", "Årsta", "Storvreta", "Gränby"],
  },
  {
    slug: "solcellstvatt-nacka",
    service: "Solcellstvätt",
    city: "Nacka",
    region: "Stockholms län",
    priceFrom: "3 499 kr",
    heroImage: "/solceller.png",
    title: "Solcellstvätt Nacka – maximera din elproduktion | HPR",
    description: "Solcellstvätt i Nacka och Saltsjöbaden med avjoniserat vatten. Rena paneler ger upp till 20% mer effekt. Fasta paketpriser från 3 499 kr.",
    h1: "Solcellstvätt i Nacka",
    kicker: "Solcellstvätt · Nacka & Saltsjöbaden",
    intro: [
      "I sjönära Nacka och Saltsjöbaden samlar solpanelerna snabbt på sig pollen, salt och fågelspillning som sänker elproduktionen. HPR utför skonsam solcellstvätt i hela Nacka med egna team.",
      "Vi tvättar panelerna med avjoniserat vatten – repfritt och kemikaliefritt – så att de producerar maximalt igen. Fast paketpris efter antal paneler, utan överraskningar.",
    ],
    areas: ["Saltsjöbaden", "Boo", "Fisksätra", "Saltsjö-Boo", "Älta", "Orminge", "Sickla", "Duvnäs"],
  },
  {
    slug: "solcellstvatt-taby",
    service: "Solcellstvätt",
    city: "Täby",
    region: "Stockholms län",
    priceFrom: "3 499 kr",
    heroImage: "/solceller.png",
    title: "Solcellstvätt Täby – mer el från dina paneler | HPR",
    description: "Solcellstvätt i Täby med avjoniserat vatten. Ta bort smuts och pollen och få upp till 20% mer effekt. Fasta paketpriser från 3 499 kr.",
    h1: "Solcellstvätt i Täby",
    kicker: "Solcellstvätt · Täby & Roslagen",
    intro: [
      "I Täby med omnejd blir solpanelerna snabbt nedsmutsade av pollen, damm och fågelspillning – vilket kan sänka produktionen rejält. HPR utför skonsam solcellstvätt i Täby med egna team.",
      "Med avjoniserat vatten rengör vi panelerna repfritt och helt utan kemikalier, så att de producerar för fullt igen. Du väljer ett fast paketpris efter antal paneler.",
    ],
    areas: ["Näsbypark", "Gribbylund", "Roslags-Näsby", "Viggbyholm", "Ella Gård", "Skarpäng", "Hägernäs", "Vallentuna"],
  },

  {
    slug: "taktvatt-danderyd",
    service: "Taktvätt",
    city: "Danderyd",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Danderyd – skonsam takrengöring | HPR",
    description: "Taktvätt i Danderyd, Djursholm och Stocksund. Skonsam mjuktvätt för villans tak som tar bort mossa och alger. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Danderyd",
    kicker: "Taktvätt · Djursholm & Stocksund",
    intro: [
      "Danderyd med Djursholm och Stocksund har många äldre, påkostade villor med stora tegeltak – ytor där mossa och alger gärna får fäste med tiden. HPR utför skonsam taktvätt i hela Danderyd med egna certifierade team.",
      "Vi arbetar med lågtrycks-mjuktvätt och biologiskt nedbrytbara medel som varsamt löser upp påväxten utan att skada de ofta värdefulla takpannorna. Du får fri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Djursholm", "Stocksund", "Enebyberg", "Danderyd kyrka", "Mörby", "Golfbanan", "Rinkebyskogen", "Kevinge"],
  },
  {
    slug: "takmalning-danderyd",
    service: "Takmålning",
    city: "Danderyd",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Danderyd – måla taket med garanti | HPR",
    description: "Takmålning i Danderyd, Djursholm och Stocksund av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Danderyd",
    kicker: "Takmålning · Djursholm & Stocksund",
    intro: [
      "Ett vackert hus i Danderyd förtjänar ett tak i toppskick. En professionell takmålning ger både ett nytt utseende och ett skyddande ytskikt som håller i många år. HPR rengör alltid taket noggrant innan vi målar.",
      "Vår beprövade process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. Vi sköter hela ROT-administrationen åt dig.",
    ],
    areas: ["Djursholm", "Stocksund", "Enebyberg", "Danderyd kyrka", "Mörby", "Golfbanan", "Rinkebyskogen", "Kevinge"],
  },
  {
    slug: "taktvatt-sundbyberg",
    service: "Taktvätt",
    city: "Sundbyberg",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Sundbyberg – ta bort mossa & alger | HPR",
    description: "Taktvätt i Sundbyberg med skonsam mjuktvätt. Vi tar bort mossa, alger och lav från villans tak. Fast pris, ROT-avdrag och kostnadsfri besiktning.",
    h1: "Taktvätt i Sundbyberg",
    kicker: "Taktvätt · Sundbyberg",
    intro: [
      "I tätbebyggda Sundbyberg med villor i bland annat Duvbo och Storskogen sätter sig mossa och alger snabbt på taken, särskilt på skuggiga sidor. HPR utför skonsam taktvätt i hela Sundbyberg med egna takproffs.",
      "Istället för aggressiv högtryckstvätt använder vi lågtrycks-mjuktvätt med miljövänliga medel som skyddar takytan. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Duvbo", "Storskogen", "Lilla Alby", "Hallonbergen", "Ör", "Rissne", "Ursvik", "Brotorp"],
  },
  {
    slug: "takmalning-sundbyberg",
    service: "Takmålning",
    city: "Sundbyberg",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Sundbyberg – 10 års garanti | HPR",
    description: "Takmålning i Sundbyberg av egna certifierade takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Sundbyberg",
    kicker: "Takmålning · Sundbyberg",
    intro: [
      "En takmålning i Sundbyberg förlänger takets livslängd och lyfter husets utseende rejält. HPR tvättar alltid taket rent från mossa och alger innan vi målar, så att färgen fäster som den ska.",
      "Med vår process – grundning och två strykningar väderbeständig färg – och egna team levererar vi ett fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Duvbo", "Storskogen", "Lilla Alby", "Hallonbergen", "Ör", "Rissne", "Ursvik", "Brotorp"],
  },
  {
    slug: "taktvatt-knivsta",
    service: "Taktvätt",
    city: "Knivsta",
    region: "Uppsala län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Knivsta – skonsam takrengöring | HPR",
    description: "Taktvätt i Knivsta med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och kostnadsfri besiktning på plats.",
    h1: "Taktvätt i Knivsta",
    kicker: "Taktvätt · Knivsta",
    intro: [
      "Knivsta, mitt emellan Uppsala och Stockholm, är en snabbt växande kommun med både nyare och äldre villor omgivna av mycket grönska – en perfekt miljö för mossa och alger på taken. HPR utför skonsam taktvätt i hela Knivsta med egna team.",
      "Vi använder lågtrycks-mjuktvätt med biologiskt nedbrytbara medel som tar bort påväxten utan att slita på takytan. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Centrala Knivsta", "Alsike", "Ar", "Nydal", "Gredelby", "Vrå", "Lagga", "Östuna"],
  },
  {
    slug: "takmalning-knivsta",
    service: "Takmålning",
    city: "Knivsta",
    region: "Uppsala län",
    priceFrom: "26 600 kr",
    title: "Takmålning Knivsta – måla taket med 10 års garanti | HPR",
    description: "Takmålning i Knivsta av egna takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Knivsta",
    kicker: "Takmålning · Knivsta",
    intro: [
      "En takmålning i Knivsta ger huset ett nytt utseende och skyddar taket mot väder och vind i många år framåt. HPR rengör alltid taket ordentligt innan vi målar, så att resultatet håller länge.",
      "Vår process med grundning och två strykningar väderbeständig färg utförs av egna team till fast pris med upp till 10 års garanti. Vi sköter ROT-administrationen åt dig.",
    ],
    areas: ["Centrala Knivsta", "Alsike", "Ar", "Nydal", "Gredelby", "Vrå", "Lagga", "Östuna"],
  },
  {
    slug: "taktvatt-balsta",
    service: "Taktvätt",
    city: "Bålsta",
    region: "Uppsala län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Bålsta – skonsam takrengöring | HPR",
    description: "Taktvätt i Bålsta och Håbo med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Bålsta",
    kicker: "Taktvätt · Bålsta & Håbo",
    intro: [
      "I mälarnära Bålsta och Håbo kommun gör den fuktiga luften att mossa och alger trivs extra bra på taken. HPR utför skonsam taktvätt i hela området med egna certifierade team.",
      "Vi arbetar med lågtrycks-mjuktvätt och miljövänliga medel som löser upp påväxten skonsamt. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Centrala Bålsta", "Skokloster", "Bista", "Gröna dalen", "Väppeby", "Kalmarsand", "Krägga", "Yttergran"],
  },
  {
    slug: "takmalning-balsta",
    service: "Takmålning",
    city: "Bålsta",
    region: "Uppsala län",
    priceFrom: "26 600 kr",
    title: "Takmålning Bålsta – måla taket med garanti | HPR",
    description: "Takmålning i Bålsta och Håbo av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Bålsta",
    kicker: "Takmålning · Bålsta & Håbo",
    intro: [
      "En takmålning i Bålsta fräschar upp huset och ger taket ett hållbart skydd mot det mälarnära, fuktiga klimatet. HPR rengör alltid taket noggrant innan vi målar så att färgen fäster och håller.",
      "Vår beprövade process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Centrala Bålsta", "Skokloster", "Bista", "Gröna dalen", "Väppeby", "Kalmarsand", "Krägga", "Yttergran"],
  },

  {
    slug: "taktvatt-jarfalla",
    service: "Taktvätt",
    city: "Järfälla",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Järfälla – skonsam takrengöring | HPR",
    description: "Taktvätt i Järfälla med skonsam mjuktvätt. Vi tar bort mossa, alger och lav från villans tak. Fast pris, ROT-avdrag och kostnadsfri besiktning.",
    h1: "Taktvätt i Järfälla",
    kicker: "Taktvätt · Jakobsberg & Barkarby",
    intro: [
      "I Järfälla med villaområden i Jakobsberg, Viksjö och Kallhäll får mossa och alger snabbt fäste på taken, särskilt på äldre betong- och tegeltak. HPR utför skonsam taktvätt i hela Järfälla med egna certifierade team – aldrig underleverantörer.",
      "Vi använder lågtrycks-mjuktvätt med biologiskt nedbrytbara medel som löser upp påväxten utan att skada takpannorna. Du får kostnadsfri besiktning, ett fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Jakobsberg", "Barkarby", "Kallhäll", "Viksjö", "Skälby", "Stäket", "Barkarbystaden", "Berghem"],
  },
  {
    slug: "takmalning-jarfalla",
    service: "Takmålning",
    city: "Järfälla",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Järfälla – måla taket med 10 års garanti | HPR",
    description: "Takmålning i Järfälla av egna takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Järfälla",
    kicker: "Takmålning · Jakobsberg & Barkarby",
    intro: [
      "En takmålning i Järfälla lyfter husets utseende och ger taket ett skyddande ytskikt som håller i många år. HPR rengör alltid taket noggrant innan vi målar, så att färgen fäster som den ska.",
      "Vår beprövade process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. Vi sköter hela ROT-administrationen åt dig.",
    ],
    areas: ["Jakobsberg", "Barkarby", "Kallhäll", "Viksjö", "Skälby", "Stäket", "Barkarbystaden", "Berghem"],
  },
  {
    slug: "taktvatt-huddinge",
    service: "Taktvätt",
    city: "Huddinge",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Huddinge – ta bort mossa & alger | HPR",
    description: "Taktvätt i Huddinge med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Huddinge",
    kicker: "Taktvätt · Huddinge & Flemingsberg",
    intro: [
      "Huddinges många villaområden – från Stuvsta och Segeltorp till Skogås och Trångsund – har ofta skogsnära lägen där mossa och alger trivs på taken. HPR utför skonsam taktvätt i hela Huddinge med egna takproffs.",
      "Istället för aggressiv högtryckstvätt använder vi lågtrycks-mjuktvätt med miljövänliga medel som skyddar takytan. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Flemingsberg", "Stuvsta", "Segeltorp", "Trångsund", "Skogås", "Vårby", "Sjödalen", "Snättringe"],
  },
  {
    slug: "takmalning-huddinge",
    service: "Takmålning",
    city: "Huddinge",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Huddinge – 10 års garanti | HPR",
    description: "Takmålning i Huddinge av egna certifierade takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Huddinge",
    kicker: "Takmålning · Huddinge & Flemingsberg",
    intro: [
      "Vill du förlänga takets livslängd och slippa byta tak i onödan? En professionell takmålning i Huddinge fräschar upp taket och ger ett hållbart skydd i många år. HPR tvättar alltid taket rent innan målning.",
      "Med vår process – grundning och två strykningar väderbeständig färg – och egna team levererar vi ett fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Flemingsberg", "Stuvsta", "Segeltorp", "Trångsund", "Skogås", "Vårby", "Sjödalen", "Snättringe"],
  },
  {
    slug: "taktvatt-tyreso",
    service: "Taktvätt",
    city: "Tyresö",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Tyresö – skonsam takrengöring | HPR",
    description: "Taktvätt i Tyresö med skonsam mjuktvätt. Vi tar bort mossa, alger och lav från villans tak. Fast pris, ROT-avdrag och kostnadsfri besiktning.",
    h1: "Taktvätt i Tyresö",
    kicker: "Taktvätt · Trollbäcken & Tyresö Strand",
    intro: [
      "I natursköna Tyresö, med villor i Trollbäcken, Bollmora och Tyresö Strand nära vatten och skog, är påväxt av mossa och alger på taken vanligt. HPR utför skonsam taktvätt i hela Tyresö med egna certifierade team.",
      "Vi arbetar med lågtrycks-mjuktvätt och biologiskt nedbrytbara medel som tar bort påväxten utan att slita på takytan. Du får fri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Trollbäcken", "Bollmora", "Tyresö Strand", "Krusboda", "Öringe", "Lindalen", "Fornudden", "Brevik"],
  },
  {
    slug: "takmalning-tyreso",
    service: "Takmålning",
    city: "Tyresö",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Tyresö – måla taket med garanti | HPR",
    description: "Takmålning i Tyresö av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Tyresö",
    kicker: "Takmålning · Trollbäcken & Tyresö Strand",
    intro: [
      "En takmålning i Tyresö ger huset ett rejält ansiktslyft och skyddar taket mot det väderutsatta läget nära vatten och skog. HPR rengör alltid taket ordentligt innan vi målar, så att färgen fäster och håller.",
      "Vår beprövade process med grundning och två strykningar väderbeständig färg utförs av egna team till fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Trollbäcken", "Bollmora", "Tyresö Strand", "Krusboda", "Öringe", "Lindalen", "Fornudden", "Brevik"],
  },
  {
    slug: "taktvatt-lidingo",
    service: "Taktvätt",
    city: "Lidingö",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Lidingö – skonsam takrengöring | HPR",
    description: "Taktvätt på Lidingö med skonsam mjuktvätt. Sjönära villor drabbas ofta av alger och mossa – vi rengör varsamt. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt på Lidingö",
    kicker: "Taktvätt · Lidingö",
    intro: [
      "Lidingös sjönära villaområden är vackra – men den fuktiga luften gör att alger och mossa trivs extra bra på taken här. HPR utför skonsam taktvätt på hela Lidingö med egna takproffs.",
      "Vi arbetar med lågtrycks-mjuktvätt och miljövänliga medel som tar bort påväxten utan att skada de ofta värdefulla takpannorna. Du får fri besiktning, ett fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Bodal", "Larsberg", "Skärsätra", "Käppala", "Brevik", "Gångsätra", "Rudboda", "Sticklinge"],
  },
  {
    slug: "takmalning-lidingo",
    service: "Takmålning",
    city: "Lidingö",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Lidingö – måla taket med garanti | HPR",
    description: "Takmålning på Lidingö av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning på Lidingö",
    kicker: "Takmålning · Lidingö",
    intro: [
      "Ett vackert hus på Lidingö förtjänar ett tak i toppskick. En professionell takmålning ger både ett nytt utseende och ett skyddande ytskikt som håller i många år. HPR rengör alltid taket noggrant innan vi målar.",
      "Vår beprövade process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. Vi sköter hela ROT-administrationen åt dig.",
    ],
    areas: ["Bodal", "Larsberg", "Skärsätra", "Käppala", "Brevik", "Gångsätra", "Rudboda", "Sticklinge"],
  },
  {
    slug: "taktvatt-akersberga",
    service: "Taktvätt",
    city: "Åkersberga",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Åkersberga – ta bort mossa & alger | HPR",
    description: "Taktvätt i Åkersberga och Österåker med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Åkersberga",
    kicker: "Taktvätt · Österåker & Roslagen",
    intro: [
      "I Åkersberga och Österåker, med skärgårdsnära villaområden och mycket grönska, är fuktig luft en perfekt grogrund för mossa och alger på taken. HPR utför skonsam taktvätt i hela Österåker med egna certifierade team.",
      "Vi använder lågtrycks-mjuktvätt med biologiskt nedbrytbara medel som löser upp påväxten skonsamt. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Åkersberga", "Österskär", "Svinninge", "Margretelund", "Rydbo", "Täljö", "Runö", "Skärgårdsstad"],
  },
  {
    slug: "takmalning-akersberga",
    service: "Takmålning",
    city: "Åkersberga",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Åkersberga – 10 års garanti | HPR",
    description: "Takmålning i Åkersberga och Österåker av egna takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Åkersberga",
    kicker: "Takmålning · Österåker & Roslagen",
    intro: [
      "Ett väderutsatt tak i skärgårdsnära Åkersberga mår bra av en professionell takmålning som ger ett nytt, skyddande ytskikt. HPR rengör alltid taket noggrant innan vi målar så att resultatet håller länge.",
      "Vår process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. Vi sköter hela ROT-administrationen.",
    ],
    areas: ["Åkersberga", "Österskär", "Svinninge", "Margretelund", "Rydbo", "Täljö", "Runö", "Skärgårdsstad"],
  },
  {
    slug: "taktvatt-vallentuna",
    service: "Taktvätt",
    city: "Vallentuna",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Vallentuna – skonsam takrengöring | HPR",
    description: "Taktvätt i Vallentuna med skonsam mjuktvätt. Vi tar bort mossa, alger och lav från villans tak. Fast pris, ROT-avdrag och kostnadsfri besiktning.",
    h1: "Taktvätt i Vallentuna",
    kicker: "Taktvätt · Vallentuna & Roslagen",
    intro: [
      "Vallentuna med sina lantliga och skogsnära villaområden är en miljö där mossa och alger snabbt får fäste på taken. HPR utför skonsam taktvätt i hela Vallentuna med egna takproffs.",
      "Vi arbetar med lågtrycks-mjuktvätt och biologiskt nedbrytbara medel som skyddar takytan. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Centrala Vallentuna", "Bällsta", "Karby", "Brottby", "Kårsta", "Lindholmen", "Ormsta", "Össeby"],
  },
  {
    slug: "takmalning-vallentuna",
    service: "Takmålning",
    city: "Vallentuna",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Vallentuna – måla taket med garanti | HPR",
    description: "Takmålning i Vallentuna av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Vallentuna",
    kicker: "Takmålning · Vallentuna & Roslagen",
    intro: [
      "En takmålning i Vallentuna förlänger takets livslängd och lyfter husets utseende. HPR tvättar alltid taket rent från mossa och alger innan vi målar, så att färgen fäster som den ska.",
      "Med vår process – grundning och två strykningar väderbeständig färg – och egna team levererar vi ett fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Centrala Vallentuna", "Bällsta", "Karby", "Brottby", "Kårsta", "Lindholmen", "Ormsta", "Össeby"],
  },
  {
    slug: "taktvatt-upplands-vasby",
    service: "Taktvätt",
    city: "Upplands Väsby",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Upplands Väsby – ta bort mossa & alger | HPR",
    description: "Taktvätt i Upplands Väsby med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Upplands Väsby",
    kicker: "Taktvätt · Upplands Väsby",
    intro: [
      "I Upplands Väsby, med villaområden i bland annat Bollstanäs, Smedby och Runby, sätter sig mossa och alger gärna på taken. HPR utför skonsam taktvätt i hela kommunen med egna certifierade team.",
      "Vi använder lågtrycks-mjuktvätt med miljövänliga medel som tar bort påväxten utan att slita på takytan. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Centrala Väsby", "Bollstanäs", "Smedby", "Runby", "Odenslunda", "Vilunda", "Sanda", "Fresta"],
  },
  {
    slug: "takmalning-upplands-vasby",
    service: "Takmålning",
    city: "Upplands Väsby",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Upplands Väsby – 10 års garanti | HPR",
    description: "Takmålning i Upplands Väsby av egna takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Upplands Väsby",
    kicker: "Takmålning · Upplands Väsby",
    intro: [
      "En takmålning i Upplands Väsby ger huset ett nytt utseende och skyddar taket mot väder och vind i många år framåt. HPR rengör alltid taket ordentligt innan vi målar, så att resultatet håller länge.",
      "Vår process med grundning och två strykningar väderbeständig färg utförs av egna team till fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Centrala Väsby", "Bollstanäs", "Smedby", "Runby", "Odenslunda", "Vilunda", "Sanda", "Fresta"],
  },
  {
    slug: "taktvatt-norrtalje",
    service: "Taktvätt",
    city: "Norrtälje",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Norrtälje – skonsam takrengöring | HPR",
    description: "Taktvätt i Norrtälje och Roslagen med skonsam mjuktvätt. Vi tar bort mossa, alger och lav från villans tak. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Norrtälje",
    kicker: "Taktvätt · Norrtälje & Roslagen",
    intro: [
      "I Norrtälje och Roslagen, med kust- och skärgårdsnära bebyggelse, är den salta, fuktiga luften en perfekt miljö för alger och mossa på taken. HPR utför skonsam taktvätt i hela Norrtälje kommun med egna team.",
      "Vi arbetar med lågtrycks-mjuktvätt och biologiskt nedbrytbara medel som löser upp påväxten varsamt. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Centrala Norrtälje", "Rimbo", "Hallstavik", "Älmsta", "Rånäs", "Grisslehamn", "Bergshamra", "Vätö"],
  },
  {
    slug: "takmalning-norrtalje",
    service: "Takmålning",
    city: "Norrtälje",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Norrtälje – måla taket med garanti | HPR",
    description: "Takmålning i Norrtälje och Roslagen av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Norrtälje",
    kicker: "Takmålning · Norrtälje & Roslagen",
    intro: [
      "Ett väderutsatt tak i kust- och skärgårdsnära Norrtälje mår bra av en professionell takmålning som ger ett nytt, skyddande ytskikt. HPR rengör alltid taket noggrant innan vi målar så att resultatet håller länge.",
      "Vår process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. Vi sköter hela ROT-administrationen.",
    ],
    areas: ["Centrala Norrtälje", "Rimbo", "Hallstavik", "Älmsta", "Rånäs", "Grisslehamn", "Bergshamra", "Vätö"],
  },
  {
    slug: "taktvatt-haninge",
    service: "Taktvätt",
    city: "Haninge",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Haninge – ta bort mossa & alger | HPR",
    description: "Taktvätt i Haninge med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och kostnadsfri besiktning.",
    h1: "Taktvätt i Haninge",
    kicker: "Taktvätt · Handen & Västerhaninge",
    intro: [
      "Haninge med villaområden i Handen, Vendelsö och Västerhaninge har ofta skogs- och kustnära lägen där mossa och alger trivs på taken. HPR utför skonsam taktvätt i hela Haninge med egna takproffs.",
      "Istället för aggressiv högtryckstvätt använder vi lågtrycks-mjuktvätt med miljövänliga medel som skyddar takytan. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Handen", "Brandbergen", "Jordbro", "Vendelsö", "Västerhaninge", "Tungelsta", "Dalarö", "Österhaninge"],
  },
  {
    slug: "takmalning-haninge",
    service: "Takmålning",
    city: "Haninge",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Haninge – 10 års garanti | HPR",
    description: "Takmålning i Haninge av egna certifierade takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Haninge",
    kicker: "Takmålning · Handen & Västerhaninge",
    intro: [
      "En takmålning i Haninge förlänger takets livslängd och lyfter husets utseende rejält. HPR tvättar alltid taket rent från mossa och alger innan vi målar, så att färgen fäster som den ska.",
      "Med vår process – grundning och två strykningar väderbeständig färg – och egna team levererar vi ett fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Handen", "Brandbergen", "Jordbro", "Vendelsö", "Västerhaninge", "Tungelsta", "Dalarö", "Österhaninge"],
  },
  {
    slug: "taktvatt-ekero",
    service: "Taktvätt",
    city: "Ekerö",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Ekerö – skonsam takrengöring | HPR",
    description: "Taktvätt på Ekerö och Mälaröarna med skonsam mjuktvätt. Vi tar bort mossa, alger och lav från villans tak. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt på Ekerö",
    kicker: "Taktvätt · Ekerö & Mälaröarna",
    intro: [
      "På Ekerö och Mälaröarna, omgivna av Mälaren, gör den fuktiga luften att alger och mossa trivs extra bra på taken. HPR utför skonsam taktvätt i hela Ekerö kommun med egna certifierade team.",
      "Vi arbetar med lågtrycks-mjuktvätt och biologiskt nedbrytbara medel som tar bort påväxten utan att slita på takytan. Du får fri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Ekerö centrum", "Stenhamra", "Munsö", "Adelsö", "Färingsö", "Träkvista", "Sundby", "Drottningholm"],
  },
  {
    slug: "takmalning-ekero",
    service: "Takmålning",
    city: "Ekerö",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Ekerö – måla taket med garanti | HPR",
    description: "Takmålning på Ekerö och Mälaröarna av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning på Ekerö",
    kicker: "Takmålning · Ekerö & Mälaröarna",
    intro: [
      "En takmålning på Ekerö fräschar upp huset och ger taket ett hållbart skydd mot det mälarnära, fuktiga klimatet. HPR rengör alltid taket noggrant innan vi målar så att färgen fäster och håller.",
      "Vår beprövade process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Ekerö centrum", "Stenhamra", "Munsö", "Adelsö", "Färingsö", "Träkvista", "Sundby", "Drottningholm"],
  },
  {
    slug: "taktvatt-vaxholm",
    service: "Taktvätt",
    city: "Vaxholm",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Vaxholm – rengöring nära vatten | HPR",
    description: "Taktvätt i Vaxholm med skonsam mjuktvätt. Skärgårdsnära hus drabbas ofta av alger och mossa – vi rengör varsamt. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Vaxholm",
    kicker: "Taktvätt · Vaxholm & skärgården",
    intro: [
      "Vaxholm och de skärgårdsnära öarna är vackra – men den salta, fuktiga luften gör att alger och mossa trivs extra bra på taken här. HPR utför skonsam taktvätt i hela Vaxholm med egna takproffs.",
      "Vi arbetar med lågtrycks-mjuktvätt och miljövänliga medel som tar bort påväxten utan att skada takytan. Du får fri besiktning, ett fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Vaxholm stad", "Rindö", "Resarö", "Bogesund", "Kullön", "Karlsudd", "Överby", "Tynningö"],
  },
  {
    slug: "takmalning-vaxholm",
    service: "Takmålning",
    city: "Vaxholm",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Vaxholm – måla taket med garanti | HPR",
    description: "Takmålning i Vaxholm av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Vaxholm",
    kicker: "Takmålning · Vaxholm & skärgården",
    intro: [
      "Ett väderutsatt tak i skärgårdsnära Vaxholm mår bra av en professionell takmålning som ger ett nytt, skyddande ytskikt. HPR rengör alltid taket noggrant innan vi målar så att resultatet håller länge.",
      "Vår process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. Vi sköter hela ROT-administrationen.",
    ],
    areas: ["Vaxholm stad", "Rindö", "Resarö", "Bogesund", "Kullön", "Karlsudd", "Överby", "Tynningö"],
  },
  {
    slug: "taktvatt-upplands-bro",
    service: "Taktvätt",
    city: "Upplands-Bro",
    region: "Stockholms län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Upplands-Bro – skonsam takrengöring | HPR",
    description: "Taktvätt i Upplands-Bro med skonsam mjuktvätt. Vi tar bort mossa, alger och lav i Kungsängen och Bro. Fast pris, ROT-avdrag och kostnadsfri besiktning.",
    h1: "Taktvätt i Upplands-Bro",
    kicker: "Taktvätt · Kungsängen & Bro",
    intro: [
      "I Upplands-Bro med tätorterna Kungsängen och Bro, nära Mälaren, gör den fuktiga luften att mossa och alger trivs på taken. HPR utför skonsam taktvätt i hela kommunen med egna certifierade team.",
      "Vi använder lågtrycks-mjuktvätt med biologiskt nedbrytbara medel som löser upp påväxten skonsamt. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Kungsängen", "Bro", "Tibble", "Brunna", "Ekhammar", "Håtuna", "Håbo-Tibble", "Bergaslätten"],
  },
  {
    slug: "takmalning-upplands-bro",
    service: "Takmålning",
    city: "Upplands-Bro",
    region: "Stockholms län",
    priceFrom: "26 600 kr",
    title: "Takmålning Upplands-Bro – 10 års garanti | HPR",
    description: "Takmålning i Upplands-Bro av egna takproffs. Tvätt, grundning och två strykningar kvalitetsfärg i Kungsängen och Bro. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Upplands-Bro",
    kicker: "Takmålning · Kungsängen & Bro",
    intro: [
      "En takmålning i Upplands-Bro ger huset ett nytt utseende och skyddar taket mot väder och vind i många år framåt. HPR rengör alltid taket ordentligt innan vi målar, så att resultatet håller länge.",
      "Vår process med grundning och två strykningar väderbeständig färg utförs av egna team till fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Kungsängen", "Bro", "Tibble", "Brunna", "Ekhammar", "Håtuna", "Håbo-Tibble", "Bergaslätten"],
  },
  {
    slug: "taktvatt-tierp",
    service: "Taktvätt",
    city: "Tierp",
    region: "Uppsala län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Tierp – skonsam takrengöring | HPR",
    description: "Taktvätt i Tierp med skonsam mjuktvätt. Vi tar bort mossa, alger och lav och ger taket nytt liv. Fast pris, ROT-avdrag och kostnadsfri besiktning på plats.",
    h1: "Taktvätt i Tierp",
    kicker: "Taktvätt · Tierp & norra Uppland",
    intro: [
      "I Tierp och norra Uppland, med mycket skog och landsbygd runt husen, får mossa och alger snabbt fäste på taken. HPR utför skonsam taktvätt i hela Tierps kommun med egna certifierade team.",
      "Vi använder lågtrycks-mjuktvätt med miljövänliga medel som tar bort påväxten utan att slita på takytan. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Centrala Tierp", "Söderfors", "Örbyhus", "Skärplinge", "Karlholmsbruk", "Månkarbo", "Tobo", "Upplanda"],
  },
  {
    slug: "takmalning-tierp",
    service: "Takmålning",
    city: "Tierp",
    region: "Uppsala län",
    priceFrom: "26 600 kr",
    title: "Takmålning Tierp – måla taket med 10 års garanti | HPR",
    description: "Takmålning i Tierp av egna takproffs. Tvätt, grundning och två strykningar kvalitetsfärg. Fast pris, ROT-avdrag och upp till 10 års garanti.",
    h1: "Takmålning i Tierp",
    kicker: "Takmålning · Tierp & norra Uppland",
    intro: [
      "En takmålning i Tierp lyfter husets utseende och skyddar taket mot väder och vind i många år framåt. HPR rengör alltid taket ordentligt innan vi målar, så att färgen fäster och håller.",
      "Vår beprövade process med grundning och två strykningar väderbeständig färg utförs av egna team till fast pris med upp till 10 års garanti. ROT-avdraget sköter vi åt dig.",
    ],
    areas: ["Centrala Tierp", "Söderfors", "Örbyhus", "Skärplinge", "Karlholmsbruk", "Månkarbo", "Tobo", "Upplanda"],
  },
  {
    slug: "taktvatt-osthammar",
    service: "Taktvätt",
    city: "Östhammar",
    region: "Uppsala län",
    priceFrom: "14 900 kr",
    title: "Taktvätt Östhammar – rengöring nära kusten | HPR",
    description: "Taktvätt i Östhammar och Öregrund med skonsam mjuktvätt. Kustnära hus drabbas ofta av alger och mossa – vi rengör varsamt. Fast pris, ROT-avdrag och fri besiktning.",
    h1: "Taktvätt i Östhammar",
    kicker: "Taktvätt · Östhammar & Öregrund",
    intro: [
      "I Östhammar och Öregrund, med kustnära bebyggelse vid Roslagens norra del, gör den salta, fuktiga luften att alger och mossa trivs extra bra på taken. HPR utför skonsam taktvätt i hela kommunen med egna team.",
      "Vi arbetar med lågtrycks-mjuktvätt och biologiskt nedbrytbara medel som löser upp påväxten varsamt. Du får kostnadsfri besiktning, fast pris och ROT-avdrag direkt på fakturan.",
    ],
    areas: ["Östhammar stad", "Öregrund", "Gimo", "Alunda", "Österbybruk", "Hargshamn", "Dannemora", "Harg"],
  },
  {
    slug: "takmalning-osthammar",
    service: "Takmålning",
    city: "Östhammar",
    region: "Uppsala län",
    priceFrom: "26 600 kr",
    title: "Takmålning Östhammar – måla taket med garanti | HPR",
    description: "Takmålning i Östhammar och Öregrund av egna proffs. Tvätt, grundning och två strykningar kvalitetsfärg med upp till 10 års garanti. Fast pris och ROT-avdrag.",
    h1: "Takmålning i Östhammar",
    kicker: "Takmålning · Östhammar & Öregrund",
    intro: [
      "Ett väderutsatt tak i kustnära Östhammar mår bra av en professionell takmålning som ger ett nytt, skyddande ytskikt. HPR rengör alltid taket noggrant innan vi målar så att resultatet håller länge.",
      "Vår process – mjuktvätt, grundning och två strykningar väderbeständig färg – utförs av egna team till fast pris med upp till 10 års garanti. Vi sköter hela ROT-administrationen.",
    ],
    areas: ["Östhammar stad", "Öregrund", "Gimo", "Alunda", "Österbybruk", "Hargshamn", "Dannemora", "Harg"],
  },
  {
    slug: "solcellstvatt-solna",
    service: "Solcellstvätt",
    city: "Solna",
    region: "Stockholms län",
    priceFrom: "3 499 kr",
    heroImage: "/solceller.png",
    title: "Solcellstvätt Solna – upp till 20% mer effekt | HPR",
    description: "Solcellstvätt i Solna med avjoniserat vatten. Rena paneler ger upp till 20% mer effekt. Fasta paketpriser från 3 499 kr för villor och BRF:er.",
    h1: "Solcellstvätt i Solna",
    kicker: "Solcellstvätt · Solna",
    intro: [
      "I tätbebyggda Solna, med både villor och större bostadsrättsföreningar, samlar solpanelerna snabbt på sig damm, pollen och sot som sänker elproduktionen. HPR utför skonsam solcellstvätt i hela Solna med egna team.",
      "Vi tvättar panelerna med avjoniserat (rent) vatten – helt kemikaliefritt och repfritt – så att de producerar maximalt igen. Du väljer ett fast paketpris efter antal paneler, utan överraskningar.",
    ],
    areas: ["Huvudsta", "Bergshamra", "Hagalund", "Råsunda", "Bagartorp", "Järva", "Ulriksdal", "Frösunda"],
  },
  {
    slug: "solcellstvatt-sollentuna",
    service: "Solcellstvätt",
    city: "Sollentuna",
    region: "Stockholms län",
    priceFrom: "3 499 kr",
    heroImage: "/solceller.png",
    title: "Solcellstvätt Sollentuna – mer el från panelerna | HPR",
    description: "Solcellstvätt i Sollentuna med avjoniserat vatten. Ta bort damm och pollen och få upp till 20% mer effekt. Fasta paketpriser från 3 499 kr.",
    h1: "Solcellstvätt i Sollentuna",
    kicker: "Solcellstvätt · Sollentuna",
    intro: [
      "I Sollentunas många villaområden blir solpanelerna snabbt nedsmutsade av pollen, damm och fågelspillning – vilket kan sänka produktionen rejält. HPR utför skonsam solcellstvätt i hela Sollentuna med egna team.",
      "Med avjoniserat vatten rengör vi panelerna repfritt och helt utan kemikalier, så att de producerar för fullt igen. Du väljer ett fast paketpris efter antal paneler.",
    ],
    areas: ["Edsberg", "Norrviken", "Rotebro", "Häggvik", "Tureberg", "Viby", "Sjöberg", "Helenelund"],
  },
  {
    slug: "solcellstvatt-jarfalla",
    service: "Solcellstvätt",
    city: "Järfälla",
    region: "Stockholms län",
    priceFrom: "3 499 kr",
    heroImage: "/solceller.png",
    title: "Solcellstvätt Järfälla – maximera din elproduktion | HPR",
    description: "Solcellstvätt i Järfälla med avjoniserat vatten. Rena paneler ger upp till 20% mer effekt. Fasta paketpriser från 3 499 kr.",
    h1: "Solcellstvätt i Järfälla",
    kicker: "Solcellstvätt · Jakobsberg & Barkarby",
    intro: [
      "I Järfälla med villaområden i Jakobsberg, Viksjö och Kallhäll blir solpanelerna snabbt smutsiga av pollen, damm och fågelspillning. Smutsiga paneler ger mindre el – HPR utför skonsam solcellstvätt i hela Järfälla med egna team.",
      "Vi tvättar panelerna med avjoniserat vatten – repfritt och kemikaliefritt – så att de producerar maximalt igen. Fast paketpris efter antal paneler, utan överraskningar.",
    ],
    areas: ["Jakobsberg", "Barkarby", "Kallhäll", "Viksjö", "Skälby", "Stäket", "Barkarbystaden", "Berghem"],
  },
  {
    slug: "solcellstvatt-huddinge",
    service: "Solcellstvätt",
    city: "Huddinge",
    region: "Stockholms län",
    priceFrom: "3 499 kr",
    heroImage: "/solceller.png",
    title: "Solcellstvätt Huddinge – rena paneler, mer el | HPR",
    description: "Solcellstvätt i Huddinge med avjoniserat vatten. Ta bort smuts och pollen och få upp till 20% mer effekt. Fasta paketpriser från 3 499 kr.",
    h1: "Solcellstvätt i Huddinge",
    kicker: "Solcellstvätt · Huddinge & Flemingsberg",
    intro: [
      "I Huddinges skogsnära villaområden samlar solpanelerna snabbt på sig pollen, damm och fågelspillning som sänker elproduktionen. HPR utför skonsam solcellstvätt i hela Huddinge med egna team.",
      "Med avjoniserat vatten tvättar vi panelerna repfritt och helt utan kemikalier, så att de åter producerar för fullt. Du väljer ett fast paketpris efter antal paneler.",
    ],
    areas: ["Flemingsberg", "Stuvsta", "Segeltorp", "Trångsund", "Skogås", "Vårby", "Sjödalen", "Snättringe"],
  },
  {
    slug: "solcellstvatt-enkoping",
    service: "Solcellstvätt",
    city: "Enköping",
    region: "Uppsala län",
    priceFrom: "3 499 kr",
    heroImage: "/solceller.png",
    title: "Solcellstvätt Enköping – mer el från dina paneler | HPR",
    description: "Solcellstvätt i Enköping med avjoniserat vatten. Rena paneler ger upp till 20% mer effekt. Fasta paketpriser från 3 499 kr.",
    h1: "Solcellstvätt i Enköping",
    kicker: "Solcellstvätt · Enköping",
    intro: [
      "I Enköping med mycket grönska runt husen blir solpanelerna snabbt nedsmutsade av pollen, damm och fågelspillning – vilket kan sänka produktionen rejält. HPR utför skonsam solcellstvätt i Enköping med egna team.",
      "Med avjoniserat vatten rengör vi panelerna repfritt och helt utan kemikalier, så att de producerar för fullt igen. Du väljer ett fast paketpris efter antal paneler.",
    ],
    areas: ["Centrala Enköping", "Romberga", "Bergvreten", "Korsängen", "Munksundet", "Fanna", "Örsundsbro", "Grillby"],
  },
];

const normalizeWarrantyText = (value) => {
  if (typeof value === "string") return value.replace(/upp till 10 års garanti/gi, "10 års garanti");
  if (Array.isArray(value)) return value.map(normalizeWarrantyText);
  if (value && typeof value === "object") {
    Object.keys(value).forEach((key) => { value[key] = normalizeWarrantyText(value[key]); });
  }
  return value;
};

locations.forEach(normalizeWarrantyText);

export const getLocation = (slug) => locations.find((l) => l.slug === slug);
